import get from 'lodash.get';
import getIsB2C from './is-b2c';

const getMyyolaUrl = (rootState) => {
  if (getIsB2C(rootState)) {
    return get(rootState, 'config.common.myyola.url');
  }

  return get(rootState, 'config.common.myyola.wl_url');
};

export default getMyyolaUrl;
